module.exports = __webpack_public_path__ + "490f5cae9507d4c79797a51b377b1729.png";